import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonical, 
  ogImage, 
  ogType = 'website',
  noindex = false 
}) => {
  const siteName = "La Ferme À L'Ancienne";
  const siteUrl = "https://lafermeancienne.fr";
  const defaultImage = `${siteUrl}/images/VACHES.png`;
  const defaultDescription = "La Ferme À L'Ancienne - Exploitation familiale depuis 1936, agriculture biologique depuis 2009. Viandes de qualité supérieure au Lude (72800).";
  const defaultKeywords = "ferme ancienne, viande bio, agriculture biologique, Le Lude, 72800, viande qualité, bœuf bio, porc bio, agneau bio, volaille bio, charcuterie, exploitation familiale, viande locale, producteur local";

  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Viandes Bio de Qualité au Lude (72800)`;
  const metaDescription = description || defaultDescription;
  const metaKeywords = keywords || defaultKeywords;
  const metaImage = ogImage || defaultImage;
  const canonicalUrl = canonical || siteUrl;

  return (
    <Helmet>
      {/* Titre et description de base */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      
      {/* Robots */}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Hreflang pour le français */}
      <link rel="alternate" hreflang="fr" href={canonicalUrl} />
      <link rel="alternate" hreflang="x-default" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
      
      {/* Schema.org - peut être surchargé par chaque page si nécessaire */}
    </Helmet>
  );
};

export default SEO;

